var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.28979,
    y: 21.4111,
    width: 22.36,
    height: 2.83936,
    transform: "rotate(-40.2798 6.28979 21.4111)",
    fill: "#00020F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.44751,
    y: 7.57031,
    width: 2.83936,
    height: 2.83936,
    transform: "rotate(-40.2798 9.44751 7.57031)",
    fill: "#00020F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.449,
    y: 7.90015,
    width: 2.83936,
    height: 2.83936,
    transform: "rotate(-40.2798 13.449 7.90015)",
    fill: "#00020F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4507,
    y: 8.23047,
    width: 2.83936,
    height: 2.83936,
    transform: "rotate(-40.2798 17.4507 8.23047)",
    fill: "#00020F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1223,
    y: 12.5627,
    width: 2.83936,
    height: 2.83936,
    transform: "rotate(-40.2798 21.1223 12.5627)",
    fill: "#00020F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7925,
    y: 16.5649,
    width: 2.83936,
    height: 2.83936,
    transform: "rotate(-40.2798 20.7925 16.5649)",
    fill: "#00020F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.4617,
    y: 20.5667,
    width: 2.83936,
    height: 2.83936,
    transform: "rotate(-40.2798 20.4617 20.5667)",
    fill: "#00020F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowBlack);
export default __webpack_public_path__ + "assets/media/rotate-arrow-black.9584b153d29bf24a7cad8810c64d66c9.svg";
export { ForwardRef as ReactComponent };